// This file is used to map the fields for the Utah's NGL Disclosure Form
import { getNGLFieldNames } from '@/components/documents/Foxit/FormMapping/FieldNameProviders/NGLFieldNameProvider'
import { useFormFillHelper } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { useIdentitySetup } from '@/components/documents/Foxit/FormMapping/composables/IdentityFields'

export default class NGLUTDisclosureForm {
	private fieldNameProvider = getNGLFieldNames()

	// Standard list of fields for this form.
	// These values point to field names in the fieldNameProvider, as well as functions to get the value for the field via the fieldValueProvider
	private fields: (keyof typeof this.fieldNameProvider)[] = ['funeralHomeName']

	private unfilledFields = [
		'agentToProviderRelationshipEmployeeCheck',
		'agentToProviderRelationshipAgentCheck',
		'agentToProviderRelationshipNoneCheck',
		'agentToProviderRelationshipOtherCheck',
		'agentToProviderRelationshipOtherDesc',
		'agentToProviderRelationshipOtherDesc2',
		'agentToSellerRelationshipEmployeeCheck',
		'agentToSellerRelationshipAgentCheck',
		'agentToSellerRelationshipNoneCheck',
		'agentToSellerRelationshipOtherCheck',
		'agentToSellerRelationshipOtherDesc',
		'agentToSellerRelationshipOtherDesc2',
		'sellerToProviderRelationshipEmployeeCheck',
		'sellerToProviderRelationshipAgentCheck',
		'sellerToProviderRelationshipNoneCheck',
		'sellerToProviderRelationshipOtherCheck',
		'sellerToProviderRelationshipOtherDesc',
		'sellerToInsurerRelationshipAgentCheck',
		'sellerToInsurerRelationshipNoneCheck',
		'sellerToInsurerRelationshipOtherCheck',
		'sellerToInsurerRelationshipOtherDesc',
		'providerToInsurerRelationshipAgentCheck',
		'providerToInsurerRelationshipNoneCheck',
		'providerToInsurerRelationshipOtherCheck',
		'providerToInsurerRelationshipOtherDesc',
	]

	// Setup prior to building form filling array.
	constructor(planHolderId: string) {
		const { identitySetup } = useIdentitySetup()
		const { setFieldNameProvider } = useFormFillHelper()

		identitySetup(planHolderId, ['funeralHome'])
		setFieldNameProvider(this.fieldNameProvider)
	}

	// Build form filling array.
	getFormMappings() {
		const { mapFields } = useFormFillHelper()

		return mapFields(this.fields)
	}
}
